import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUpload } from './file-upload.component';
import { DropZoneDirective } from '../../../_directives/drop-zone.directive';
import { FileSizePipe } from '../../../_pipes/file-size.pipe'

// import { ConfirmDialogModule, ConfirmationService } from 'primeng/primeng';

@NgModule({
    imports: [CommonModule],
    declarations: [FileUpload, DropZoneDirective, FileSizePipe],
    providers: [],
    exports: [FileUpload]
})
export class FileUploadModule { }


// WEBPACK FOOTER //
// ./src/app/theme/layouts/file-upload/file-upload.module.ts